<template>
	<div class="wrapper">
		<!-- <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}"> -->
		<sidebar-fixed-toggle-button />
		<side-bar style="background-color: #fff !important;">
			<!-- <mobile-menu slot="content"></mobile-menu> -->
			<template slot="links" v-if="utilizador.nivel == '1'">
				<sidebar-link
					v-if="utilizador.nivel == '1' || utilizador.nivel == '2'"
					:link="{
						name: 'Registos',
						icon: 'tim-icons icon-pencil',
						path: '/promotor',
					}"
				>
				</sidebar-link>
				<!-- <sidebar-link
					:link="{
						name: 'Chat / Galeria',
						icon: 'tim-icons icon-chat-33',
						path: '/chat',
					}"
				>
				</sidebar-link> -->
				<sidebar-link
					:link="{
						name: 'Alertas',
						icon: 'tim-icons icon-bell-55',
						path: '/alertas',
					}"
				>
				</sidebar-link>
				<sidebar-link
					:link="{
						name: 'Admin',
						icon: 'tim-icons icon-chart-pie-36',
						path: '/classificacao',
					}"
				>
				</sidebar-link>

				<li class="router-link-active">
					<a href="#" @click="modalAtividadesFunction()" class="nav-link"
						><i class="tim-icons icon-settings-gear-63"></i>
						<p>Fechar inscrições</p></a
					>
				</li>

				<li class="router-link-active">
					<a href="/" @click="logout()" class="nav-link"
						><i class="tim-icons icon-user-run"></i>
						<p>Logout</p></a
					>
				</li>
			</template>
			<template slot="links" v-if="utilizador.nivel == '2'">
				<sidebar-link
					v-if="utilizador.nivel == '1' || utilizador.nivel == '2'"
					:link="{
						name: 'Registos',
						icon: 'tim-icons icon-pencil',
						path: '/promotor',
					}"
				>
				</sidebar-link>
				<!-- <sidebar-link
					:link="{
						name: 'Chat / Galeria',
						icon: 'tim-icons icon-chat-33',
						path: '/chat',
					}"
				>
				</sidebar-link> -->
				<sidebar-link
					:link="{
						name: 'Alertas',
						icon: 'tim-icons icon-bell-55',
						path: '/alertas',
					}"
				>
				</sidebar-link>
				<sidebar-link
					:link="{
						name: 'Classificação',
						icon: 'tim-icons icon-chart-pie-36',
						path: '/classificacao',
					}"
				>
				</sidebar-link>
				<li class="router-link-active">
					<a href="/" @click="logout()" class="nav-link"
						><i class="tim-icons icon-user-run"></i>
						<p>Logout</p></a
					>
				</li>
			</template>
			<template slot="links" v-if="utilizador.nivel == '3'">
				<sidebar-link
					v-if="grupo == '0'"
					:link="{
						name: 'Grupos',
						icon: 'tim-icons icon-notes',
						path: '/dashboard',
					}"
				>
				</sidebar-link>
				<sidebar-link
					v-if="grupo != '0'"
					:link="{
						name: 'Atividades',
						icon: 'tim-icons icon-user-run',
						path: '/atividades',
					}"
				>
				</sidebar-link>
				<!-- <sidebar-link
					:link="{
						name: 'Chat / Galeria',
						icon: 'tim-icons icon-chat-33',
						path: '/chat',
					}"
				>
				</sidebar-link> -->
				<sidebar-link
					:link="{
						name: 'Alertas',
						icon: 'tim-icons icon-bell-55',
						path: '/alertas',
					}"
				>
				</sidebar-link>
				<sidebar-link
					:link="{
						name: 'Classificação',
						icon: 'tim-icons icon-chart-pie-36',
						path: '/classificacao',
					}"
				>
				</sidebar-link>

				<li class="router-link-active">
					<a href="#" @click="modalAgenda = true" class="nav-link"
						><i class="tim-icons  icon-calendar-60"></i>
						<p>Agenda</p></a
					>
				</li>

				<li class="router-link-active">
					<a href="/" @click="logout()" class="nav-link"
						><i class="tim-icons icon-user-run"></i>
						<p>Logout</p></a
					>
				</li>
			</template>
		</side-bar>
		<sidebar-share :background-color.sync="backgroundColor"></sidebar-share>

		<div class="main-panel" :data="backgroundColor">
			<top-navbar></top-navbar>

			<dashboard-content @click.native="toggleSidebar"></dashboard-content>

			<content-footer></content-footer>
		</div>
		<modal :show.sync="modalAgenda">
			<h2 slot="header" class="title title-up text-left">Agenda</h2>
			<div v-if="utilizador.grupo != 0" class="text-left">
				<p>
					O seu grupo é:
					<b>
						{{
							utilizador.grupo == "0"
								? "Sem tribo"
								: utilizador.grupo == "1"
								? "Tribo Terra"
								: "Tribo Água"
						}}</b
					>
				</p>
			</div>
			<div v-if="atividades.length > 0" class="text-left">
				<div v-for="(atividade, i) in atividades" :key="i">
					<p>
						<b>{{ atividade.hora }} horas: </b>{{ atividade.nome }}
					</p>
				</div>
			</div>
			<div v-else>
				<p>Ainda não se registou em nenhuma atividade</p>
			</div>
		</modal>
		<modal :show.sync="modalAtividades">
			<h2 slot="header" class="title title-up text-left">Fechar inscrições</h2>
			<div v-if="atividadesInfo.length > 0" class="text-left">
				<div v-for="(atividadeLoop, i) in atividadesInfo" :key="i">
					<div class="row">
						<div class="col">
							<p>
								{{ atividadeLoop.atividade }}h -
								<b
									>{{ "Inscrições "
									}}<span
										:class="
											atividadeLoop.encerrada == '0' ? 'verde' : 'vermelho'
										"
										>{{
											atividadeLoop.encerrada == "0" ? "abertas" : "fechadas"
										}}</span
									></b
								>
							</p>
						</div>
						<div class="col">
							<base-button
								v-if="atividadeLoop.encerrada == '0'"
								@click="atualizarAtividades(atividadeLoop)"
								class="mb-3 bg_edp_verde"
								size="sm"
								simple
							>
								Fechar inscrições
							</base-button>
							<base-button
								v-else
								@click="atualizarAtividades(atividadeLoop)"
								class="mb-3 bg_edp_verde"
								size="sm"
								simple
							>
								Abrir inscrições
							</base-button>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<style lang="scss"></style>
<script>
	import TopNavbar from "./TopNavbar.vue";
	import ContentFooter from "./ContentFooter.vue";
	import DashboardContent from "./DashboardContent.vue";
	import SidebarShare from "./SidebarSharePlugin.vue";
	import SideBar from "@/components/SidebarPlugin/SideBar.vue";
	import SidebarLink from "@/components/SidebarPlugin/SidebarLink.vue";
	import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
	import { Modal } from "@/components/index";
	import api from "@/api/index";

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter,
			SideBar,
			SidebarLink,
			SidebarShare,
			SidebarFixedToggleButton,
			Modal,
		},
		data() {
			return {
				backgroundColor: "green",
				utilizador: [],
				atividades: [],
				atividadesInfo: [],
				grupo: "",
				modalAgenda: false,
				modalAtividades: false,
			};
		},
		computed: {
			isRTL() {
				return this.$rtl.isRTL;
			},
		},
		methods: {
			async modalAtividadesFunction() {
				this.modalAtividades = true;
			},
			async atualizarAtividades(array) {
				let json = {
					atividade: array.atividade,
					valor: array.encerrada == "0" ? "1" : "0",
				};

				let res = await api.atualizarAtividadesInfo(json);
				if (res) {
					if (res.resultado == "OK") {
						this.inicio();
					}
				}
			},
			logout() {
				localStorage.removeItem("active-session-niu");
			},
			async inicio() {
				var user_id = localStorage.getItem("active-session-niu");
				var jsonUser = {
					user_id: user_id,
				};
				let res = await api.buscarDados(jsonUser);
				if (Object.values(res).length > 0) {
					this.utilizador = Object.values(res)[0];
					this.grupo = this.utilizador.grupo;
					var atividades = this.utilizador.atividades.split(",");
					atividades = atividades.sort(function(a, b) {
						return a > b ? 1 : -1;
					});

					let resAtividades = await api.buscarAtividades();
					resAtividades = Object.values(resAtividades);
					var checker = [...new Set(atividades)].length > 1 ? true : false;
					if (atividades.length > 0 && checker) {
						for (let i = 0; i < atividades.length; i++) {
							if (atividades[i] != "") {
								this.atividades.push({
									nome: resAtividades.find((x) => x.id == atividades[i]).nome,
									hora: resAtividades.find((x) => x.id == atividades[i]).hora,
								});
							}
						}
					}
					this.atividades = this.atividades.sort(function(a, b) {
						return Number(a.hora) < Number(b.hora) ? -1 : 1;
					});
				}
				let resAtividades = await api.buscarAtividadesInfo();
				this.atividadesInfo = Object.values(resAtividades);
			},
			toggleSidebar() {
				if (this.$sidebar.showSidebar) {
					this.$sidebar.displaySidebar(false);
				}
			},
		},
		mounted() {
			this.inicio();
		},
	};
</script>

<style>
	@media only screen and (min-width: 576px) {
		.modal-dialog {
			max-width: 540px;
			margin: 1.75rem auto;
		}
	}
	.verde {
		color: #28ff52;
	}
	.vermelho {
		color: red;
	}
</style>
